import { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';

import { useLocalization } from 'localization';

type Props = {
  icon?: ReactNode;
  title: string;
};

const CardTitleHeader = (props: Props) => {
  const { icon, title } = props;
  const { t } = useLocalization();
  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      {icon}
      <Typography variant="h5">{t(title)}</Typography>
    </Stack>
  );
};

export default CardTitleHeader;
